<template>
  <div v-if="show" class="quick-register-overlay" @click.self="close">
    <div class="quick-register-modal">
      <div class="qr-modal-header">
        <img src="@/assets/logos/Promolider.png" alt="Promolíder" class="logo" />
        <h2>Registro Rápido</h2>
        <p v-if="type === 'free'">Crea tu cuenta para acceder al curso</p>
        <p v-else>Crea tu cuenta VIP para acceder a tus beneficios</p>
        <button class="close-btn" @click="close">&times;</button>
      </div>
      
      <div class="modal-body">
        <form @submit.prevent="submitRegistration" autocomplete="off">
          <!-- Datos Básicos -->
          <div class="form-row">
            <div class="form-group half">
              <label>Nombres *</label>
              <input type="text" v-model="form.name" required />
            </div>
            <div class="form-group half">
              <label>Apellidos *</label>
              <input type="text" v-model="form.last_name" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>Correo Electrónico *</label>
              <input type="email" v-model="form.email" required @blur="checkAvailability('email')" />
              <small class="error-text" v-if="errors.email">{{ errors.email }}</small>
            </div>
            <div class="form-group half">
              <label>Usuario *</label>
              <input type="text" v-model="form.username" required @input="usernameTouched = true" @blur="checkAvailability('username')" autocomplete="off" />
              <small class="error-text" v-if="errors.username">{{ errors.username }}</small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>País *</label>
              <select v-model="form.id_country" required>
                <option value="" disabled>Selecciona tu país</option>
                <option v-for="c in countries" :key="c.id" :value="c.id">
                  {{ c.name }}
                </option>
              </select>
            </div>
            <div class="form-group half">
              <label>WhatsApp / Teléfono *</label>
              <div class="phone-input-group">
                <select v-model="phonePrefix" class="phone-prefix-select">
                  <option value="+51">+51</option>
                  <option value="+52">+52</option>
                  <option value="+57">+57</option>
                  <option value="+54">+54</option>
                  <option value="+56">+56</option>
                  <option value="+593">+593</option>
                  <option value="+58">+58</option>
                  <option value="+591">+591</option>
                  <option value="+595">+595</option>
                  <option value="+598">+598</option>
                  <option value="+502">+502</option>
                  <option value="+503">+503</option>
                  <option value="+504">+504</option>
                  <option value="+505">+505</option>
                  <option value="+506">+506</option>
                  <option value="+507">+507</option>
                  <option value="+34">+34</option>
                  <option value="+1">+1</option>
                </select>
                <input type="tel" v-model="form.phone_number" required placeholder="Número" />
              </div>
            </div>
          </div>

          <!-- Documento y Ubicación -->
          <div class="form-row">
            <div class="form-group half">
              <label>Tipo de Documento *</label>
              <select v-model="form.id_document_type" required @change="checkAvailability('nro_document')">
                <option value="" disabled>Selecciona tu tipo de documento</option>
                <option v-for="d in documentTypes" :key="d.id" :value="d.id">
                  {{ d.document }}
                </option>
              </select>
            </div>
            <div class="form-group half">
              <label>Nro. de Documento *</label>
              <input type="text" v-model="form.nro_document" required @blur="checkAvailability('nro_document')" />
              <small class="error-text" v-if="errors.nro_document">{{ errors.nro_document }}</small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group half">
              <label>Fecha de Nacimiento *</label>
              <input type="date" v-model="form.date_birth" required />
            </div>
            <div class="form-group half">
              <label>Ciudad *</label>
              <input type="text" v-model="form.city" required autocomplete="none" />
            </div>
          </div>

          <!-- Contraseña -->
          <div class="form-row">
            <div class="form-group half">
              <label>Contraseña *</label>
              <div class="password-wrapper">
                <input :type="showPassword ? 'text' : 'password'" v-model="form.password" required minlength="6" autocomplete="new-password" />
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" class="toggle-password" @click="showPassword = !showPassword"></i>
              </div>
            </div>
            <div class="form-group half">
              <label>Confirmar *</label>
              <div class="password-wrapper">
                <input :type="showRepassword ? 'text' : 'password'" v-model="repassword" required minlength="6" autocomplete="new-password" />
                <i :class="showRepassword ? 'fas fa-eye-slash' : 'fas fa-eye'" class="toggle-password" @click="showRepassword = !showRepassword"></i>
              </div>
            </div>
          </div>
          
          <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>

          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Procesando...</span>
            <span v-else>Completar Registro</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { authSet } from "@/helpers/authStorage";

export default {
  name: 'QuickRegisterModal',
  props: {
    show: Boolean,
    type: String, // 'free' or 'vip'
    refId: String,
    planId: [String, Number]
  },
  data() {
    return {
      loading: false,
      errorMsg: '',
      errors: {},
      countries: [],
      documentTypes: [],
      phonePrefix: '+51',
      showPassword: false,
      showRepassword: false,
      usernameTouched: false,
      repassword: '',
      form: {
        name: '',
        last_name: '',
        email: '',
        username: '',
        id_country: '',
        phone_number: '',
        id_document_type: '',
        nro_document: '',
        date_birth: '',
        city: '',
        password: ''
      }
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.usernameTouched = false;
        this.errors = {};
        if (this.countries.length === 0) {
          this.fetchFormData();
        }
      }
    },
    'form.email'(newVal) {
      if ((!this.usernameTouched || !this.form.username) && newVal) {
        let base = newVal.split('@')[0].replace(/[^a-zA-Z0-9]/g, '');
        if (base) {
          // add a small random number just in case
          this.form.username = base + Math.floor(Math.random() * 100);
        } else {
          this.form.username = '';
        }
      } else if (!newVal) {
        this.form.username = '';
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async fetchFormData() {
      try {
        const response = await this.axios.get('/registration/form-data');
        if (response.data && response.data.data) {
          this.countries = response.data.data.countries || [];
          this.documentTypes = response.data.data.document_types || [];
        }
      } catch (err) {
        console.error("Error loading form data", err);
      }
    },
    async checkAvailability(field) {
      if (!this.form[field]) return;
      
      try {
        const payload = { field, value: this.form[field] };
        if (field === 'nro_document' && this.form.id_document_type) {
          payload.document_type = this.form.id_document_type;
        }

        const res = await this.axios.post('/registration/check-availability', payload);
        
        if (res.data && res.data.success && !res.data.available) {
          const nombres = {
            username: 'Este nombre de usuario',
            email: 'Este correo electrónico',
            nro_document: 'Este número de documento'
          };
          this.$set(this.errors, field, `${nombres[field] || 'Este dato'} ya está en uso.`);
        } else {
          this.$delete(this.errors, field);
        }
      } catch (err) {
        console.error('Error validando el campo', field, err);
      }
    },
    async submitRegistration() {
      if (Object.keys(this.errors).length > 0) {
        this.errorMsg = 'Por favor, corrige los errores antes de continuar.';
        return;
      }
      
      if (this.form.password !== this.repassword) {
        this.errorMsg = 'Las contraseñas no coinciden.';
        return;
      }
      
      this.loading = true;
      this.errorMsg = '';
      
      try {
        // Prepare payload
        const refIdParsed = parseInt(this.refId, 10);
        
        const payload = {
          ...this.form,
          phone: `${this.phonePrefix} ${this.form.phone_number}`,
          id_account_type: this.type === 'vip' ? this.planId : 7, // 7=Consumidor Invitado
          id_referrer_sponsor: isNaN(refIdParsed) || refIdParsed === 0 ? 1 : refIdParsed,
          user_type: this.type === 'vip' ? 'Distributor' : ''
        };

        console.log("PAYLOAD TO SEND:", payload);

        // 1. Create User
        await this.axios.post('/registration/create', payload);

        // 2. Auto-Login
        const loginRes = await this.axios.post('/auth/login', {
          username: this.form.email,
          password: this.form.password
        });
        
        // Save token properly
        if (loginRes.data && loginRes.data.data) {
          const authData = loginRes.data.data;
          const authToken = authData.access_token;
          const userData = authData.user;
          
          if (authToken) {
            authSet("access_token", authToken);
            authSet("id_user", userData.id);
            authSet("rol_user", userData.id_account_type);
            authSet("name_user", userData.name);
            authSet("last_name_user", userData.last_name);
            authSet("email_user", userData.email);
            
            this.axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
          }
        }
        
        // 3. Redirect Based on Type
        if (this.type === 'vip') {
          const baseUrl = process.env.VUE_APP_CRM_URL || 'http://localhost:5173';
          window.location.href = `${baseUrl}/payment/openpay?plan=${this.planId}`;
        } else {
          this.$emit('success');
        }

      } catch (err) {
        console.error(err);
        if (err.response && err.response.data && err.response.data.errors) {
          const errors = err.response.data.errors;
          this.errorMsg = Object.values(errors).flat()[0];
        } else if (err.response && err.response.data && err.response.data.message) {
          this.errorMsg = err.response.data.message;
        } else {
          this.errorMsg = 'Ocurrió un error en el registro. Intenta nuevamente.';
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.quick-register-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(5px);
}
.quick-register-modal {
  background: #111;
  border: 1px solid #333;
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.5);
  color: #fff;
  max-height: 90vh;
  overflow-y: auto;
}
.qr-modal-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #222;
  position: relative;
  display: block; /* Override any potential flex inheritance */
}
.qr-modal-header .logo {
  height: 40px;
  margin-bottom: 12px;
  display: inline-block;
}
.qr-modal-header h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
}
.qr-modal-header p {
  color: #9ca3af;
  font-size: 14px;
  margin: 0;
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #666;
  font-size: 28px;
  cursor: pointer;
}
.close-btn:hover {
  color: #fff;
}
.modal-body {
  padding: 24px;
}
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}
.form-group {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.form-group.half {
  flex: 1;
}
.form-group label {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 6px;
  font-weight: 600;
}
.form-group input, .form-group select {
  background: #000;
  border: 1px solid #333;
  color: #fff;
  padding: 12px;
  border-radius: 8px;
  outline: none;
  font-family: inherit;
  font-size: 14px;
}
.form-group select option {
  color: #fff;
  background: #111;
}
.form-group select:invalid, .form-group select option[value=""] {
  color: #9ca3af;
}
.form-group input:focus, .form-group select:focus {
  border-color: #18d600;
}
.phone-prefix-select {
  background: #000;
  border: none;
  border-right: 1px solid #333;
  color: #fff;
  padding: 12px 28px 12px 12px;
  outline: none;
  border-radius: 8px 0 0 8px;
  width: 90px;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%239ca3af" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 6px center;
}
.phone-prefix-select option {
  color: #fff;
  background: #111;
}
.phone-input-group {
  display: flex;
  background: #000;
  border: 1px solid #333;
  border-radius: 8px;
  overflow: hidden;
  height: 47px;
}
.phone-input-group:focus-within {
  border-color: #18d600;
}
.phone-input-group input {
  border: none;
  border-radius: 0 8px 8px 0;
  flex: 1;
}
.phone-input-group input:focus {
  border: none;
}
.password-wrapper {
  position: relative;
  display: flex;
}
.password-wrapper input {
  width: 100%;
  padding-right: 40px;
}
.toggle-password {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}
.toggle-password:hover {
  color: #fff;
}
.submit-btn {
  width: 100%;
  background: linear-gradient(90deg, #18d600, #12a100);
  border: none;
  color: white;
  font-weight: 700;
  padding: 14px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: opacity 0.3s;
}
.submit-btn:hover {
  opacity: 0.9;
}
.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.error-msg {
  color: #ff4d4d;
  font-size: 0.9rem;
  margin-top: 15px;
  text-align: center;
  background: rgba(255, 77, 77, 0.1);
  padding: 10px;
  border-radius: 6px;
}
.error-text {
  color: #ff4d4d;
  font-size: 0.75rem;
  margin-top: 4px;
  display: block;
}
.quick-register-modal::-webkit-scrollbar {
  width: 8px;
}
.quick-register-modal::-webkit-scrollbar-track {
  background: #111;
}
.quick-register-modal::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}
@media (max-width: 600px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style>
